/* GENERATED by maths-calculators/build.py, edit calcs.js not this file. */
MC_CONFIG["algebraic-fractions-calculator"] = { name: "Algebraic Fractions Calculator", fields: [{"id": "mode", "label": "What to do", "type": "select", "def": "simp", "options": [["simp", "Simplify a fraction"], ["comb", "Add or subtract two fractions"], ["solve", "Solve an equation with fractions"]]}, {"id": "n2", "group": "S", "groupLabel": "The fraction", "slot": "num", "label": "Top: number with x\u00b2", "short": "With x\u00b2", "type": "number", "def": "1", "int": true, "min": -1000, "max": 1000, "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "n1", "group": "S", "slot": "num", "label": "Top: number with x", "short": "With x", "type": "number", "def": "0", "int": true, "min": -1000, "max": 1000, "sep": "x\u00b2 +", "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "n0", "group": "S", "slot": "num", "label": "Top: number on its own", "short": "On its own", "type": "number", "def": "-9", "int": true, "min": -1000, "max": 1000, "sep": "x +", "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "d2", "group": "S", "slot": "den", "label": "Bottom: number with x\u00b2", "short": "With x\u00b2", "type": "number", "def": "1", "int": true, "min": -1000, "max": 1000, "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "d1", "group": "S", "slot": "den", "label": "Bottom: number with x", "short": "With x", "type": "number", "def": "1", "int": true, "min": -1000, "max": 1000, "sep": "x\u00b2 +", "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "d0", "group": "S", "slot": "den", "label": "Bottom: number on its own", "short": "On its own", "type": "number", "def": "-6", "int": true, "min": -1000, "max": 1000, "sep": "x +", "cls": "mc-narrow", "showIf": {"mode": ["simp"]}}, {"id": "ca", "group": "A", "groupLabel": "First fraction", "slot": "num", "label": "First fraction: top", "short": "Top", "type": "number", "def": "2", "int": true, "min": -1000, "max": 1000, "cls": "mc-narrow", "showIf": {"mode": ["comb", "solve"]}}, {"id": "cb", "group": "A", "slot": "den", "label": "First fraction: number added to x", "short": "Added to x", "type": "number", "def": "1", "int": true, "min": -1000, "max": 1000, "sep": "x +", "cls": "mc-narrow", "showIf": {"mode": ["comb", "solve"]}}, {"id": "cop", "slot": "op", "label": "Add or subtract", "type": "select", "def": "add", "options": [["add", "+"], ["sub", "\u2212"]], "showIf": {"mode": ["comb", "solve"]}}, {"id": "cc", "group": "B", "groupLabel": "Second fraction", "slot": "num", "label": "Second fraction: top", "short": "Top", "type": "number", "def": "3", "int": true, "min": -1000, "max": 1000, "cls": "mc-narrow", "showIf": {"mode": ["comb", "solve"]}}, {"id": "cd", "group": "B", "slot": "den", "label": "Second fraction: number added to x", "short": "Added to x", "type": "number", "def": "2", "int": true, "min": -1000, "max": 1000, "sep": "x +", "cls": "mc-narrow", "showIf": {"mode": ["comb", "solve"]}}, {"id": "eqs", "type": "static", "slot": "op", "text": "=", "label": "equals", "showIf": {"mode": ["solve"]}}, {"id": "ce", "group": "E", "groupLabel": "Right side", "label": "Right side", "type": "number", "def": "2", "int": true, "min": -1000, "max": 1000, "cls": "mc-narrow", "showIf": {"mode": ["solve"]}}], example: {"mode": "simp", "n2": 1, "n1": 0, "n0": -9, "d2": 1, "d1": 1, "d0": -6}, run: (function (v, H) {
      var steps = [];
      function lin(p, q) { return H.terms([[p, 'x'], [q, '']]); }
      /* factor a whole-number polynomial of degree 2 or less into
         k × (px + q)(rx + s), or k × an irreducible quadratic */
      function factor(a, b, c) {
        var out = { k: 1, lins: [], rest: null };
        if (a === 0 && b === 0) { out.k = c; return out; }
        var g = a !== 0 ? H.gcd(H.gcd(a, b), c) : H.gcd(b, c);
        var lead = a !== 0 ? a : b;
        if (lead < 0) g = -g;
        out.k = g; a /= g; b /= g; c /= g;
        if (a === 0) { out.lins.push([b, c]); return out; }
        var D = b * b - 4 * a * c, s = D >= 0 ? Math.round(Math.sqrt(D)) : -1;
        if (D >= 0 && s * s === D) {
          var p1 = -b + s, p2 = -b - s, den = 2 * a;
          var g1 = H.gcd(p1, den), g2 = H.gcd(p2, den);
          out.lins.push([den / g1, -p1 / g1], [den / g2, -p2 / g2]);
          out.lins.forEach(function (l) { if (l[0] < 0) { l[0] = -l[0]; l[1] = -l[1]; } });
        } else out.rest = [a, b, c];
        return out;
      }
      function show(f, bare) {
        var parts = f.lins.map(function (l) { return lin(l[0], l[1]); });
        if (f.rest) parts.push(H.poly(f.rest));
        var k = f.k;
        if (!parts.length) return H.fmt(k);
        var sole = parts.length === 1 && bare && k === 1;
        var body = sole ? parts[0] : parts.map(function (p) { return '(' + p + ')'; }).join('');
        if (sole) return body;
        return (k === 1 ? '' : k === -1 ? '−' : H.fmt(k)) + body;
      }
      function same(u, w) { return u[0] === w[0] && u[1] === w[1]; }
      if (v.mode === 'simp') {
        if (v.d2 === 0 && v.d1 === 0 && v.d0 === 0) throw new Error('The bottom cannot be 0.');
        var N = factor(v.n2, v.n1, v.n0), Dn = factor(v.d2, v.d1, v.d0);
        var topS = H.poly([v.n2, v.n1, v.n0]), botS = H.poly([v.d2, v.d1, v.d0]);
        if (v.n2 === 0 && v.n1 === 0 && v.n0 === 0) {
          steps.push('The top is 0, and 0 divided by anything (that is not 0) is 0: 0');
          return { answer: '0', steps: steps };
        }
        steps.push('Factorise the top: ' + topS + (show(N, true) === topS ? ', which does not factorise' : ' = ' + show(N)));
        steps.push('Factorise the bottom: ' + botS + (show(Dn, true) === botS ? ', which does not factorise' : ' = ' + show(Dn)));
        var cancelled = [];
        N.lins = N.lins.filter(function (l) {
          for (var i = 0; i < Dn.lins.length; i++) {
            if (same(l, Dn.lins[i])) { cancelled.push('(' + lin(l[0], l[1]) + ')'); Dn.lins.splice(i, 1); return false; }
          }
          return true;
        });
        if (N.rest && Dn.rest && N.rest.join() === Dn.rest.join()) { cancelled.push('(' + H.poly(N.rest) + ')'); N.rest = null; Dn.rest = null; }
        var g = H.gcd(N.k, Dn.k);
        if (Dn.k < 0) g = -g;
        var kn = N.k / g, kd = Dn.k / g;
        if (!cancelled.length && Math.abs(g) === 1) {
          var plain = H.frTok(topS, botS);
          steps.push('No bracket or number is shared by the top and the bottom, so it is already in its simplest form: ' + plain);
          return { answer: plain, steps: steps, note: 'Only whole factors cancel. The x² on the top and the x² on the bottom can never be crossed out on their own.' };
        }
        N.k = kn; Dn.k = kd;
        var topF = show(N, true), hasBottom = Dn.lins.length || Dn.rest || Dn.k !== 1;
        var ans = hasBottom ? H.frTok(topF, show(Dn, true)) : topF;
        var what = cancelled.slice();
        if (Math.abs(g) !== 1) what.push('the common number ' + H.fmt(Math.abs(g)));
        steps.push('Cancel ' + what.join(' and ') + ' from the top and the bottom: ' + ans);
        return { answer: ans, steps: steps, note: 'Only whole factors cancel. The x² on the top and the x² on the bottom can never be crossed out on their own.' };
      }
      var a = v.ca, b = v.cb, c = v.cc, d = v.cd, sg = v.cop === 'sub' ? -1 : 1, op = sg < 0 ? ' − ' : ' + ';
      var Lb = lin(1, b), Ld = lin(1, d);
      function bk(L) { return L === 'x' ? 'x' : '(' + L + ')'; }
      function times(k, L) { return (k === 1 ? '' : k === -1 ? '−' : H.fmt(k)) + bk(L); }
      var start = H.frTok(H.fmt(a), Lb) + op + H.frTok(H.fmt(c), Ld);
      var P, Q;
      if (v.mode === 'comb') {
        if (b === d) {
          var top = a + sg * c;
          steps.push('The bottoms are the same, so just ' + (sg < 0 ? 'subtract' : 'add') + ' the tops: ' + H.frTok(H.fmt(a) + op + H.fmt(c), Lb) + ' = ' + H.fmt(top) + (top === 0 ? '' : ' over ' + Lb));
          var a1 = top === 0 ? '0' : H.frTok(H.fmt(top), Lb);
          steps.push('So ' + start + ' = ' + a1);
          return { answer: a1, steps: steps };
        }
        var den = bk(Lb) + bk(Ld);
        steps.push('The common denominator is the two bottoms multiplied: ' + den);
        steps.push('Rewrite each fraction over it, multiplying top and bottom by the missing bracket: ' + H.frTok(times(a, Ld) + op + times(c, Lb), den));
        P = a + sg * c; Q = a * d + sg * c * b;
        steps.push('Multiply out the top and collect like terms: ' + H.terms([[a, 'x'], [a * d, '']]) + (sg * c < 0 ? ' − (' : ' + (') + H.terms([[c, 'x'], [c * b, '']]) + ') = ' + lin(P, Q));
        var ans2;
        if (P !== 0 && Q % P === 0 && (Q / P === b || Q / P === d)) {
          var keep = Q / P === b ? Ld : Lb;
          ans2 = H.frTok(H.fmt(P), keep);
          steps.push('The top is ' + H.fmt(P) + '(' + lin(1, Q / P) + '), which cancels with the same bracket on the bottom: ' + ans2);
        } else {
          ans2 = H.frTok(lin(P, Q), den);
          steps.push('Nothing cancels, so the answer is ' + ans2);
        }
        return { answer: ans2, steps: steps, note: 'Multiplied out, the bottom is ' + H.poly([1, b + d, b * d]) + '. Either form is fine unless the question asks for one.' };
      }
      var e = v.ce;
      steps.push('Multiply EVERY term by both bottoms, ' + bk(Lb) + bk(Ld) + ', to clear the fractions: ' + times(a, Ld) + op + times(c, Lb) + ' = ' + (e === 0 ? '0' : times(e, Lb) + bk(Ld)));
      P = a + sg * c; Q = a * d + sg * c * b;
      var A = e, B = e * (b + d) - P, C = e * b * d - Q;
      steps.push('Multiply out both sides: ' + lin(P, Q) + ' = ' + H.poly([e, e * (b + d), e * b * d]));
      var roots = [], strs = [];
      if (A === 0) {
        steps.push('Collect everything on one side: ' + lin(-B, -C) + ' = 0');
        if (B === 0) {
          steps.push(C === 0 ? 'Every term cancels, so every allowed x works' : 'The x terms cancel and leave a false statement, so there is no solution');
          return { answer: C === 0 ? 'Every allowed value of x works' : 'No solution', steps: steps };
        }
        roots = [-C / B]; strs = [H.ratStr(-C, B)];
        steps.push('Solve: x = ' + strs[0]);
      } else {
        steps.push('Collect everything on one side to get a quadratic: ' + H.poly([A, B, C]) + ' = 0');
        var qs = H.quadSolve(A, B, C, steps);
        roots = qs.roots; strs = qs.strs;
      }
      var ok = [], bad = [];
      roots.forEach(function (r, i) { if (Math.abs(r + b) < 1e-9 || Math.abs(r + d) < 1e-9) bad.push(strs[i]); else ok.push((qs && !qs.exact ? 'x ≈ ' : 'x = ') + strs[i]); });
      if (bad.length) steps.push('Reject x = ' + bad.join(' and x = ') + ', because it makes a bottom equal 0');
      if (!ok.length) {
        steps.push('No value is left, so there is no solution');
        return { answer: 'No solution', steps: steps };
      }
      var ansS = ok.join(' or ');
      steps.push('So ' + ansS);
      return { answer: ansS, steps: steps, note: 'Check by putting each answer back into the original fractions: neither bottom can be 0, and both sides must match.' };
    }), preview: (function (v, H) {
      function pt(k, s, first) {
        if (k === '?') return (first ? '' : ' + ') + '?' + s;
        var n = Number(k);
        if (n === 0) return '';
        var mag = Math.abs(n) === 1 && s ? '' : String(Math.abs(n));
        if (first) return (n < 0 ? '−' : '') + mag + s;
        return (n < 0 ? ' − ' : ' + ') + mag + s;
      }
      function q(a, b, c) { var t = pt(a, 'x²', true); t += pt(b, 'x', t === ''); t += pt(c, '', t === ''); return t || '0'; }
      function num(k) { return k === '?' ? '?' : (Number(k) < 0 ? '−' + Math.abs(Number(k)) : String(Number(k))); }
      if (v.mode === 'simp') return 'Simplify ' + H.frTok(q(v.n2, v.n1, v.n0), q(v.d2, v.d1, v.d0));
      var s = H.frTok(num(v.ca), q(0, 1, v.cb)) + (v.cop === 'sub' ? ' − ' : ' + ') + H.frTok(num(v.cc), q(0, 1, v.cd));
      return v.mode === 'solve' ? 'Solve ' + s + ' = ' + num(v.ce) : s;
    }) };
/* SHLC maths calculators: browser engine.
   Expects window.MC_HELPERS (helpers.js) and window.MC_CONFIG (generated by
   build.py from calcs.js: name, fields, example, run per handle).
   One renderer builds every calculator's fields — no calculator writes markup.
   Dawn traps: no [hidden], no window.onX slots, .is-on classes only. */
(function () {
  'use strict';

  var root = document.getElementById('shlcMc');
  if (!root) return;
  var H = window.MC_HELPERS;
  var CFG = window.MC_CONFIG || {};

  /* ---------------- hub search ---------------- */
  var search = root.querySelector('[data-mc-search]');
  if (search) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mc-card]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mc-group]'));
    var emptyMsg = root.querySelector('[data-mc-empty]');
    search.addEventListener('input', function () {
      var term = search.value.toLowerCase().trim();
      var shown = 0;
      cards.forEach(function (card) {
        var hit = (card.getAttribute('data-search') || '').indexOf(term) !== -1;
        card.classList.toggle('mc-hide', !hit);
        if (hit) shown++;
      });
      groups.forEach(function (g) {
        var any = g.querySelectorAll('[data-mc-card]:not(.mc-hide)').length > 0;
        g.classList.toggle('mc-hide', !any);
      });
      if (emptyMsg) emptyMsg.classList.toggle('is-on', shown === 0);
    });
  }

  /* ---------------- calculator ---------------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Fractions display stacked, never with a slash: helpers emit ⟦n∕d⟧ and
     this pass converts it to markup AFTER escaping, so run() output stays
     plain text and typed input can never inject HTML. Bare digit fractions
     (4/3 in a formula, 3/8 echoed from typed input) stack too; letters
     nearby (km/h, angle/360) and decimals (0.375) keep their slash. No
     lookbehind, it would crash the whole engine on older Safari. */
  function render(s) {
    return esc(s)
      .replace(/⟦([^⟦⟧∕]*)∕([^⟦⟧]*)⟧/g,
        '<span class="mc-fr"><span>$1</span><span>$2</span></span>')
      .replace(/(^|[^\d.,])(\d+)\/(\d+)(?!\.?\d|,\d)/g, function (m, pre, n, d) {
        return pre + '<span class="mc-fr"><span>' + n + '</span><span>' + d + '</span></span>';
      });
  }

  /* Formula bars (.mc-rule-f) and working-out lines (.mc-math) sit on one line
     on a wide screen but must fit a phone. Split each into nowrap chunks so a
     line can only break after an '=', ',', ':', ';' or '.', or beside a prose
     word, never inside a term like 9 + 16 and never before an '='.
     sin/cos/tan stay glued to their angle. Elements (<b>, stacked fractions)
     move whole. Already-chunked lines are skipped: re-chunking would glue the
     old chunks into one unbreakable span. */
  function isProseTok(t) {
    return /^[A-Za-z][A-Za-z']+[,.:;]?$/.test(t) && !/^(sin|cos|tan|log|ln)$/i.test(t);
  }
  function chunkRule(f) {
    if (f.querySelector('.mc-rf-c')) return;
    var nodes = Array.prototype.slice.call(f.childNodes);
    var frag = document.createDocumentFragment();
    var chunk = null, prev = '';
    function open() {
      if (chunk) return;
      chunk = document.createElement('span');
      chunk.className = 'mc-rf-c';
      frag.appendChild(chunk);
    }
    function brk() {
      if (!chunk) return;
      frag.appendChild(document.createTextNode(' '));
      chunk = null;
    }
    nodes.forEach(function (n) {
      if (n.nodeType !== 3) { open(); chunk.appendChild(n); prev = 'x'; return; }
      n.nodeValue.split(' ').forEach(function (t, j) {
        if (j > 0) {
          /* never start a line with '=': "opposite = 4" breaks after the '=' */
          /* in a list "25×6 = 150, 35×4 = 140" keep "= 150," together so the
             line breaks at the comma, not between a sum and its result */
          var listPair = /=$/.test(prev) && /,$/.test(t);
          if (!/^=/.test(t) && !listPair && (/[=,:;.]$/.test(prev) || isProseTok(prev) || isProseTok(t))) brk();
          else { open(); chunk.appendChild(document.createTextNode(' ')); }
        }
        if (t) { open(); chunk.appendChild(document.createTextNode(t)); prev = t; }
      });
    });
    f.textContent = '';
    f.appendChild(frag);
  }
  function chunkRules(el, sel) {
    if (!el) return;
    var fs = el.querySelectorAll(sel || '.mc-rule-f');
    for (var i = 0; i < fs.length; i++) chunkRule(fs[i]);
  }

  /* Working-out layout: the explanation stays as prose, the maths gets its own
     line and never wraps mid-expression. A step splits at its first ': ' when
     what follows contains an '='; a step that is pure calculation (has '=' but
     no leading explanation) becomes a maths line on its own. */
  function stepHtml(s) {
    var i = s.indexOf(': ');
    if (i > -1 && s.indexOf('=', i) > -1) {
      return s.slice(0, i + 1) + '<span class="mc-math">' + s.slice(i + 2) + '</span>';
    }
    if (i === -1 && s.indexOf('=') > -1) {
      return '<span class="mc-math">' + s + '</span>';
    }
    return s;
  }

  /* The bare control, with the full label carried as aria-label so a compact
     visible label ("Top") never costs a screen reader the real meaning. */
  function controlHtml(f, aria) {
    var name = esc(f.id);
    /* a fixed operator symbol: shown between two units, never an input */
    if (f.type === 'static') return '<span class="mc-op-sym">' + esc(f.text) + '</span>';
    var defAttr = esc(f.def == null ? '' : f.def);
    var ariaAttr = aria ? ' aria-label="' + esc(f.label) + '"' : '';
    if (f.type === 'select') {
      return '<select id="McF-' + name + '" name="' + name + '"' + ariaAttr + '>' + f.options.map(function (o) {
        return '<option value="' + esc(o[0]) + '"' + (String(o[0]) === String(f.def) ? ' selected' : '') + '>' + esc(o[1]) + '</option>';
      }).join('') + '</select>';
    }
    if (f.type === 'text') {
      return '<input id="McF-' + name + '" name="' + name + '" type="text" value="' + defAttr + '" placeholder="' + defAttr + '" autocomplete="off"' + ariaAttr + '>';
    }
    return '<input id="McF-' + name + '" name="' + name + '" type="text" inputmode="decimal" value="' + defAttr + '" placeholder="e.g. ' + defAttr + '" autocomplete="off"' + ariaAttr + '>';
  }

  function fieldHtml(f) {
    var name = esc(f.id);
    var labelBits = esc(f.label);
    if (f.suffix) labelBits += ' <span class="mc-affix">(' + esc(f.suffix) + ')</span>';
    if (f.prefix) labelBits += ' <span class="mc-affix">(' + esc(f.prefix) + ')</span>';
    return '<div class="mc-field' + (f.cls ? ' ' + esc(f.cls) : '') + '" data-field="' + name + '"><label for="McF-' + name + '">' + labelBits + '</label>' + controlHtml(f, false) +
      (f.hint ? '<p class="mc-hint">' + esc(f.hint) + '</p>' : '') + '</div>';
  }

  /* Short visible labels inside a unit, where the caption already says which
     part of the question this is. */
  var SLOT_LABEL = { whole: 'Whole', num: 'Top', den: 'Bottom' };

  /* Inside a unit the caption already says which part of the question this
     is, so "Equation 1: number with x" only needs to read "Number with x". */
  function shortLabel(f) {
    /* f.short names a box inside a unit when the generic Top/Bottom or the
       label minus its caption would not say enough (two boxes on one top) */
    if (f.short) return esc(f.short);
    if (SLOT_LABEL[f.slot]) return SLOT_LABEL[f.slot];
    var s = f.label, i = s.indexOf(': ');
    if (i > 0 && i < 20) s = s.slice(i + 2);
    return esc(s.charAt(0).toUpperCase() + s.slice(1));
  }

  function slotHtml(f) {
    var name = esc(f.id);
    var label = shortLabel(f);
    var tag = '<label for="McF-' + name + '">' + label + '</label>';
    var ctrl = controlHtml(f, true);
    /* the denominator's label goes UNDER its box, so the bar sits directly
       between the two numbers and the unit reads as a written fraction */
    var body = f.slot === 'den' ? ctrl + tag : tag + ctrl;
    return '<div class="mc-field mc-field--slot' + (f.slot === 'den' ? ' mc-field--den' : '') +
      (f.cls ? ' ' + esc(f.cls) : '') + '" data-field="' + name + '">' + body + '</div>';
  }

  /* A run of fields sharing a group becomes one bordered, colour-coded box.
     When the group has a top and a bottom it is drawn as a real fraction,
     numerator above the bar, so the boxes match the maths on the page. */
  function unitHtml(groupFields, hue) {
    var cap = '';
    for (var i = 0; i < groupFields.length; i++) {
      if (groupFields[i].groupLabel) { cap = esc(groupFields[i].groupLabel); break; }
    }
    var whole = null, nums = [], dens = [], rest = [];
    groupFields.forEach(function (f) {
      if (f.slot === 'whole') whole = f;
      else if (f.slot === 'num') nums.push(f);
      else if (f.slot === 'den') dens.push(f);
      else rest.push(f);
    });
    /* sep puts the notation itself between the boxes, e.g. "× 10", so the
       layout teaches the form instead of a hint telling you how to type it;
       post does the same AFTER a box, e.g. the closing bracket */
    function sepSlot(f) {
      return (f.sep ? '<span class="mc-sep">' + esc(f.sep) + '</span>' : '') + slotHtml(f) +
        (f.post ? '<span class="mc-sep">' + esc(f.post) + '</span>' : '');
    }
    /* one box on a fraction line stays exactly as before; a line with
       several boxes or symbols (ax + b over c) becomes a row of its own */
    function stackLine(list) {
      if (list.length === 1 && !list[0].sep && !list[0].post) return slotHtml(list[0]);
      return '<div class="mc-frac-row">' + list.map(sepSlot).join('') + '</div>';
    }
    var body;
    if (nums.length && dens.length) {
      body = '<div class="mc-frac">' +
        (whole ? slotHtml(whole) : '') +
        '<div class="mc-frac-stack">' + stackLine(nums) +
        '<span class="mc-frac-bar" aria-hidden="true"></span>' + stackLine(dens) + '</div>' +
        rest.map(function (f) { return f.sep || f.post ? '<div class="mc-frac-tail">' + sepSlot(f) + '</div>' : slotHtml(f); }).join('') + '</div>';
    } else {
      body = '<div class="mc-unit-row">' + groupFields.map(sepSlot).join('') + '</div>';
    }
    return '<div class="mc-unit mc-hue-' + hue + '" data-unit="' + esc(groupFields[0].group) + '">' +
      (cap ? '<span class="mc-unit-cap">' + cap + '</span>' : '') + body + '</div>';
  }

  function renderFields(cfg) {
    var fields = cfg.fields, html = '', i = 0, hues = {}, next = 1;
    while (i < fields.length) {
      var f = fields[i];
      if (f.slot === 'op') {
        html += '<div class="mc-op" data-field="' + esc(f.id) + '">' + controlHtml(f, true) + '</div>';
        i++;
      } else if (f.group) {
        var run = [], g = f.group;
        while (i < fields.length && fields[i].group === g) { run.push(fields[i]); i++; }
        if (!hues[g]) { hues[g] = next; next = next % 8 + 1; }
        html += unitHtml(run, hues[g]);
      } else {
        html += fieldHtml(f);
        i++;
      }
    }
    return html;
  }

  /* A field with showIf only exists for certain choices of a select, e.g.
     the "c" box only matters in quadratic mode. Hidden fields are skipped by
     validation too, so an irrelevant box can never block the calculator. */
  function fieldVisible(f, scope) {
    if (!f.showIf) return true;
    var ctrl = Object.keys(f.showIf)[0];
    var el = scope.querySelector('[name="' + ctrl + '"]');
    if (!el) return true;
    return f.showIf[ctrl].indexOf(el.value) !== -1;
  }

  function applyVisibility(cfg, scope) {
    for (var i = 0; i < cfg.fields.length; i++) {
      var wrap = scope.querySelector('[data-field="' + cfg.fields[i].id + '"]');
      if (wrap) wrap.classList.toggle('mc-hide', !fieldVisible(cfg.fields[i], scope));
    }
    /* a unit whose fields are all hidden must go too, or an empty coloured
       box is left floating between the ones that matter */
    var units = scope.querySelectorAll('[data-unit]');
    for (var u = 0; u < units.length; u++) {
      var live = units[u].querySelectorAll('.mc-field:not(.mc-hide)').length;
      units[u].classList.toggle('mc-hide', live === 0);
    }
  }

  function readValues(cfg, scope) {
    var values = {};
    for (var i = 0; i < cfg.fields.length; i++) {
      var f = cfg.fields[i];
      if (f.type === 'static') continue;
      if (!fieldVisible(f, scope)) continue;
      var el = scope.querySelector('[name="' + f.id + '"]');
      if (!el) continue;
      var raw = el.value;
      if (f.type === 'select' || f.type === 'text') {
        if (f.type === 'text' && !String(raw).trim() && !f.optional) {
          return { error: 'Fill in "' + f.label + '" first.' };
        }
        values[f.id] = raw;
        continue;
      }
      raw = String(raw).trim().replace(/,/g, '');
      if (raw === '') return { error: 'Enter a number for "' + f.label + '".', empty: true };
      var n = Number(raw);
      if (!isFinite(n)) return { error: '"' + f.label + '" needs to be a number, so letters and symbols will not work.' };
      if (f.int && !Number.isInteger(n)) return { error: '"' + f.label + '" must be a whole number.' };
      if (typeof f.min === 'number' && n < f.min) return { error: '"' + f.label + '" cannot be less than ' + f.min + '.' };
      if (typeof f.gt === 'number' && n <= f.gt) return { error: '"' + f.label + '" must be greater than ' + f.gt + '.' };
      if (typeof f.max === 'number' && n > f.max) return { error: '"' + f.label + '" cannot be more than ' + f.max + '.' };
      values[f.id] = n;
      if (f.keepRaw) values[f.id + 'Raw'] = raw;
    }
    return { values: values };
  }

  function activeScope() {
    var s = root.querySelector('[data-mc-page].is-on');
    return s || root;
  }

  function mount() {
    var scope = activeScope();
    var handle = scope.getAttribute('data-mc-page') || root.getAttribute('data-handle');
    var cfg = CFG[handle];
    var holder = scope.querySelector('[data-mc-fields]');
    var form = scope.querySelector('[data-mc-form]');
    if (!cfg || !holder || !form) return;

    holder.innerHTML = renderFields(cfg);
    /* server-rendered worked example: its working-out lines wrap on a phone too */
    chunkRules(root, '.mc-math');

    var errEl = scope.querySelector('[data-mc-error]');
    var resEl = scope.querySelector('[data-mc-result]');
    var ansEl = scope.querySelector('[data-mc-answer]');
    var stepsEl = scope.querySelector('[data-mc-steps]');
    var noteEl = scope.querySelector('[data-mc-note]');
    var prevEl = scope.querySelector('[data-mc-preview]');
    var widEl = scope.querySelector('[data-mc-widget]');
    var visEl = scope.querySelector('[data-mc-visual]');

    function showError(msg) {
      errEl.textContent = msg;
      errEl.classList.add('is-on');
      resEl.classList.remove('is-on');
    }

    /* every field's current value as displayable strings: selects verbatim,
       numbers as typed, or ? when empty/not a number. Feeds preview + widget. */
    function readRaw() {
      var raw = {};
      for (var i = 0; i < cfg.fields.length; i++) {
        var f = cfg.fields[i];
        var el = scope.querySelector('[name="' + f.id + '"]');
        if (!el) continue;
        var val = String(el.value).trim().replace(/,/g, '');
        if (f.type === 'select' || f.type === 'text') raw[f.id] = el.value;
        else raw[f.id] = val === '' || !isFinite(Number(val)) ? '?' : val;
      }
      return raw;
    }

    /* live "your question" line: missing numbers show as ? so it is always
       obvious what shape of question is being built */
    function updatePreview() {
      if (!prevEl || !cfg.preview) return;
      try {
        prevEl.innerHTML = render(cfg.preview(readRaw(), H));
      } catch (ex) {
        prevEl.innerHTML = '';
      }
    }

    /* Optional per-calc widget: a pure function of the raw values returning
       markup (usually SVG) drawn above the fields. Elements carrying
       data-mc-tap + data-set="field:value,field:value" write those values
       back into the form when tapped, so the widget IS the control and the
       hidden fields stay the single source of truth for run(), QA and fuzz.
       Stateless by design: every transition is computed at render time. */
    function updateWidget() {
      if (!widEl || !cfg.widget) return;
      try {
        var wHtml = cfg.widget(readRaw(), H);
        /* a widget may return '' to sit out (e.g. a bar model with nothing
           drawable): the container hides so no empty margin is left behind */
        widEl.innerHTML = wHtml || '';
        chunkRules(widEl);
        widEl.classList.toggle('is-on', !!wHtml);
      } catch (ex) {
        widEl.innerHTML = '';
        widEl.classList.remove('is-on');
      }
    }

    /* Optional dynamic labels: cfg.labels(raw) returns {fieldId: text} so a
       generic box ("Its length") can rename itself to the side just picked
       on the widget ("Hypotenuse length"). Static labels stay in calcs.js
       for the QA gates and as the no-widget fallback. */
    function applyLabels() {
      if (!cfg.labels) return;
      var map;
      try { map = cfg.labels(readRaw(), H); } catch (ex) { return; }
      for (var id in map) {
        /* "cap:b" renames unit b's caption, e.g. "End time" to "Duration to add" */
        if (id.indexOf('cap:') === 0) {
          var capEl = scope.querySelector('[data-unit="' + id.slice(4) + '"] .mc-unit-cap');
          if (capEl) capEl.textContent = map[id];
          continue;
        }
        var lab = scope.querySelector('[data-field="' + id + '"] label');
        if (lab) lab.textContent = map[id];
      }
    }

    /* auto = true when fired from typing: incomplete fields stay quiet, the
       result simply waits; real mistakes (letters, zero denominators) show */
    function calculate(auto) {
      errEl.classList.remove('is-on');
      var got = readValues(cfg, scope);
      if (got.error) {
        if (auto && got.empty) { resEl.classList.remove('is-on'); return; }
        showError(got.error);
        return;
      }
      var out;
      try {
        out = cfg.run(got.values, H);
      } catch (ex) {
        showError((ex && ex.message) || 'Check the values and try again.');
        return;
      }
      if (!out || out.answer == null || !out.steps || !out.steps.length) {
        showError('Check the values and try again.');
        return;
      }
      ansEl.innerHTML = render(out.answer);
      /* optional per-answer visual (e.g. the time line): drawn between the
         answer and the steps, cleared whenever a run does not send one */
      if (visEl) {
        if (out.visual) { visEl.innerHTML = out.visual; chunkRules(visEl); visEl.classList.add('is-on'); }
        else { visEl.innerHTML = ''; visEl.classList.remove('is-on'); }
      }
      stepsEl.innerHTML = out.steps.map(function (s) { return '<li>' + stepHtml(render(s)) + '</li>'; }).join('');
      chunkRules(stepsEl, '.mc-math');
      if (noteEl) {
        if (out.note) { noteEl.innerHTML = render(out.note); noteEl.classList.add('is-on'); }
        else { noteEl.classList.remove('is-on'); noteEl.innerHTML = ''; }
      }
      resEl.classList.add('is-on');
    }

    var liveTimer = null;
    function onLive() {
      applyVisibility(cfg, scope);
      applyLabels();
      updatePreview();
      updateWidget();
      window.clearTimeout(liveTimer);
      liveTimer = window.setTimeout(function () { calculate(true); }, 160);
    }

    function resetForm() {
      holder.innerHTML = renderFields(cfg);
      applyVisibility(cfg, scope);
      applyLabels();
      errEl.classList.remove('is-on');
      updatePreview();
      updateWidget();
      calculate(true);
    }

    /* one tap on the widget writes its data-set pairs into the form */
    function widgetTap(t) {
      var spec = t.getAttribute('data-set') || '';
      var pairs = spec.split(',');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].split(':');
        if (kv.length !== 2) continue;
        var el = scope.querySelector('[name="' + kv[0] + '"]');
        if (el) el.value = kv[1];
      }
      if (form.__mcLive) form.__mcLive();
    }

    if (widEl && widEl.getAttribute('data-mc-bound') !== '1') {
      widEl.setAttribute('data-mc-bound', '1');
      widEl.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-mc-tap]') : null;
        if (t && widEl.__mcTap) widEl.__mcTap(t);
      });
      widEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var t = e.target && e.target.closest ? e.target.closest('[data-mc-tap]') : null;
        if (t && widEl.__mcTap) { e.preventDefault(); widEl.__mcTap(t); }
      });
    }
    if (widEl) widEl.__mcTap = widgetTap;

    if (form.getAttribute('data-mc-bound') !== '1') {
      form.setAttribute('data-mc-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.__mcCalculate) form.__mcCalculate();
      });
      form.addEventListener('reset', function () {
        window.setTimeout(function () { if (form.__mcReset) form.__mcReset(); }, 0);
      });
      form.addEventListener('input', function () { if (form.__mcLive) form.__mcLive(); });
      form.addEventListener('change', function () { if (form.__mcLive) form.__mcLive(); });
      /* tapping a box selects the example inside it, so typing replaces it,
         no manual deleting. The one-shot mouseup guard stops the browser
         undoing the selection a moment later. */
      form.addEventListener('focusin', function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'INPUT') return;
        window.setTimeout(function () { try { t.select(); } catch (ex) {} }, 0);
        t.addEventListener('mouseup', function guard(ev) {
          ev.preventDefault();
          t.removeEventListener('mouseup', guard);
        });
      });
    }
    /* keep the listeners pointed at the newest closures after a remount */
    form.__mcCalculate = calculate;
    form.__mcReset = resetForm;
    form.__mcLive = onLive;

    /* the page opens already answered: the example is filled in, the question
       line and the full method are visible before anyone touches a key */
    applyVisibility(cfg, scope);
    applyLabels();
    updatePreview();
    updateWidget();
    calculate(true);
  }

  mount();

  if (window.__MC_HARNESS) {
    window.__mc = {
      config: CFG,
      helpers: H,
      mount: function (handle) {
        var pages = root.querySelectorAll('[data-mc-page]');
        for (var i = 0; i < pages.length; i++) {
          pages[i].classList.toggle('is-on', pages[i].getAttribute('data-mc-page') === handle);
        }
        root.setAttribute('data-handle', handle);
        mount();
      },
      calculate: function () {
        var form = activeScope().querySelector('[data-mc-form]');
        if (form && form.__mcCalculate) form.__mcCalculate();
      }
    };
  }
})();
